import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const ContactPage = Scrivito.provideObjClass("ContactPage", {
  // created by script, creation by editor deactivated
  onlyInside: "DoesNotExist",
  attributes: {
    ...defaultPageAttributes,
    firstName: "string",
    lastName: "string",
    body: ["widgetlist", { only: "SectionContentWidget" }],
    content: "widgetlist",
    inpageNavigation: ["widgetlist", { only: "InpageNavigationWidget" }],
    image: ["reference", { only: "Image" }],
    salutation: "string",
    belonging: "string",
    belongings: "referencelist",
    phoneNumber: "string",
    altPhoneNumber: "string",
    faxNumber: "string",
    street: "string",
    postalCode: "string",
    officeLocation: "string",
    altOfficeAddress: "string",
    altPostalAddress: "string",
    campus: "string",
    room: "string",
    email: "string",
    altEmail: "string",
    consultation: "string",
    sekretariat: ["reference", { only: "ContactPage" }],
    speciality: "stringlist",
    faculty: "stringlist",
    isNavigationPage: ["enum", { values: ["yes", "no"] }],
    isDeactivated: "boolean",
    lastDeactivationDate: "date",
    ladpJsonString: "string",
    pronoun: ["enum", { values: ["he/his", "she/her", "they/them"] }],
    uid: "string",
    locationName: "string",
    locationDescription: "string",
    locationStreet: "string",
    locationCity: "string",
    locationPostalCode: "string",
    locationCountry: "string",
    locationRegion: "string",
    locationRoom: "string",
    locationUrl: "string",
    postOfficeBoxNumber: "string",
    addressCountry: "string",
    addressRegion: "string",
    description: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: [
    "firstName",
    "lastName",
    "body",
    "salutation",
    "belonging",
    "phoneNumber",
    "altPhoneNumber",
    "faxNumber",
    "officeLocation",
    "altOfficeAddress",
    "altPostalAddress",
    "campus",
    "altEmail",
    "consultation",
    "title",
    "segmentName",
  ],
});

export default ContactPage;
